import { getStaticProps as pageGetStaticProps } from '@/pages/blog'
export { default } from '@/pages/blog'

export function getStaticProps(ctx: any) {
  return pageGetStaticProps({ ...ctx, locale: 'en' })
}
